import '../styles/footer.css';
import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="footer-content">
                <p className='foothead'>&copy; 2022 MovieNite</p>
                <ul className="footer-links">
                    <li><a href="/">Home</a></li>
                    <li><a href="/about">About</a></li>
                    <li><a href="/contact">Contact</a></li>
                </ul>
            </div>
        </footer>
    );
};

export default Footer;
